import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@pp/core/src/styles/core.css';

import { GtagLogger } from '@pp/core/src/logger/GtagLogger';
import { Game } from './Game';
import getVariant from './GameDetector';
import(`./styles/${getVariant()}/variables.css`);

try {
  GtagLogger.logEvent('game-load-started', undefined);
  performance.mark('loadStartForGtag');
} catch (e) {
  //nothing we can do
}

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
    <Game />
  </StrictMode>
);
